import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import {FormControlLabel, IconButton, Tooltip} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import {changeWorkQueueSession} from '../../redux/reducers/WorkQueueList';
export default function FadeMenu({columnsData, columns, setColumns}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCheckboxClick = (event, item) => {
    const {workQueueNextAccount} = changeWorkQueueSession();
    const columnsSession = JSON.parse(sessionStorage.getItem('workQueueList')) || {};
    if (event.target.checked) {
      setColumns((prevState) => {
        const obj = {...prevState};
        obj[item.title] = item;
        sessionStorage.setItem(
          'workQueueList',
          JSON.stringify({
            ...columnsSession,
            [workQueueNextAccount?.workQueueRowData?.workqueueName]: obj,
          }),
        );
        return obj;
      });
    } else {
      setColumns((prevState) => {
        const obj = {...prevState};
        delete obj[item.title];
        sessionStorage.setItem(
          'workQueueList',
          JSON.stringify({
            ...columnsSession,
            [workQueueNextAccount?.workQueueRowData?.workqueueName]: obj,
          }),
        );
        return obj;
      });
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title="Add Columns">
        <IconButton aria-label="close" onClick={handleClick}>
          <AddIcon />
        </IconButton>
      </Tooltip>

      <Menu id="fade-menu" anchorEl={anchorEl} keepMounted open={open} onClose={handleMenuClose}>
        {columnsData?.map((item, i) => {
          return (
            <MenuItem key={i}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Object.keys(columns).includes(item.title)}
                    onClick={(event) => handleCheckboxClick(event, item)}
                  />
                }
                label={item.title}
              />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
